import { IMAGES } from "./assets";

// Featured/real projects. Drop in real photos by swapping `img` URLs.
// Categories: "Commercial" | "Residential".
const JS = "https://customer-assets-rejwkqb3.emergentagent.net/job_trust-nz-build/artifacts/";

export const PROJECTS = [
  {
    id: "151-john-street",
    name: "151 John Street",
    location: "Auckland",
    category: "Residential",
    page: "/projects/151-john-street",
    services: ["Flooring Installation"],
    image: `${JS}4575b86f18584b68_Scandinavian%20Oak%20Kitchen%20Living%20Space.png`,
    gallery: [
      `${JS}663539082c2aee8a_Scandinavian%20living%20space%20with%20pale%20oak%20flooring.png`,
      `${JS}a3e99b807aa323a3_Ash%20Oak%20Corridor%20with%20Marble%20Island.png`,
      `${JS}f7396ffedda1638c_Marble%20Step%20in%20Sunlit%20Oak%20Hallway.png`,
      `${JS}0fe9ab5fcc2ebd2f_Minimalist%20Scandinavian%20Powder%20Room.png`,
    ],
    featureSlides: [
      `${JS}8e393ac678d08077_Sunlit%20Scandinavian%20Kitchen%20with%20Ash%20Oak%20Flooring.png`,
      `${JS}7f89765792fb0cee_Sunlit%20Ash-Oak%20Hallway%20with%20Garden%20Views.png`,
      `${JS}5ac15624d056df28_Sunlit%20Whitewashed%20Oak%20Dining%20Interior.png`,
      `${JS}e46d44a0f3775bc5_Sunlit%20Pale%20Oak%20Staircase.png`,
      `${JS}aac8ae59c160514a_Sunlit%20Whitewashed%20Oak%20Flooring.png`,
    ],
    blurb:
      "Trust Flooring & Interiors delivered the flooring installation for this Auckland residential project, creating a clean, cohesive finish that complements the home's architecture.",
  },
  {
    id: "five-mile-villas",
    name: "5 Mile Villas",
    location: "Queenstown",
    category: "Residential",
    services: ["Engineered Timber Flooring", "Carpet"],
    image:
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/illdbb6w_27.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/81344i8n_25.png",
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/zq9jxrsw_26.png",
    ],
    link: "https://gibbonsco.co.nz/projects/five-mile-villas",
    blurb:
      "Trust Flooring & Interiors was engaged across the full 5 Mile Villas complex — a premium multi-unit development set against the backdrop of Queenstown's remarkable landscape. Working throughout the entire development, we delivered engineered timber flooring and carpet installation across every villa, maintaining a consistent finish and tight programme across the full scope of works. A project defined by scale, coordination and an uncompromising standard of delivery from first unit to last.",
  },
  {
    id: "harcourts-hq",
    name: "Harcourts HQ",
    location: "Albany, Auckland",
    category: "Commercial",
    services: ["Timber Flooring", "Carpet Tiles"],
    image:
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/sgpuszr7_Harcourts%20-%20HQ.1.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/wtb8d9jp_Harcourts%20-%20HQ.2.png",
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/ybfj303c_Harcourts%20-%20HQ.3.png",
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/oiyusofs_Harcourts%20HQ.4%20.jpg",
    ],
    blurb:
      "Engaged to deliver the flooring fitout for Harcourts' Albany headquarters, Trust Flooring & Interiors supplied and installed timber flooring and carpet tiles throughout the commercial space. Working within the demands of a live commercial environment and a structured programme, we delivered a clean, professional finish suited to a high-profile corporate setting. A project that required precision, clear communication with the project team, and seamless execution across a multi-zone floor plan.",
  },
  {
    id: "mt-eden-residence",
    name: "Mt Eden Residence",
    location: "Auckland",
    category: "Residential",
    services: ["Engineered Timber Flooring — European Oak"],
    image:
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/kumjx8xl_IMG_20230907_112656.jpeg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/dxq1df62_IMG_20230907_112748.jpeg",
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/r2xjjeq5_IMG_20230907_113831.jpeg",
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/uhzv2zhx_IMG_20230907_112302.jpeg",
    ],
    blurb:
      "A private Mt Eden home presented the opportunity to work directly with the homeowner on a considered interior flooring selection. European Oak engineered timber was specified for its warmth, character and longevity — laid throughout the residence to create a cohesive, refined result. A quieter project in scale, but one that reflects the care and attention to detail we bring to every job regardless of size.",
  },
  {
    id: "captains-retreat",
    name: "Captains Retreat",
    location: "Auckland",
    category: "Residential",
    services: ["Engineered Timber Flooring", "Bathroom Tiling"],
    image:
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/bci1hsma_0C6A8310-14.webp",
    gallery: [
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/zx2tk3kt_0C6A8316-16.webp",
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/ohzt0b5s_058A7609-2.webp",
    ],
    blurb:
      "Engaged by the developer on this high-end architectural new build, Trust Flooring & Interiors delivered engineered timber flooring throughout the living areas and kitchen, alongside full bathroom tiling — bringing two distinct material palettes together under one cohesive finish. Captains Retreat demanded the kind of precision that high-end architectural builds require; tight tolerances, immaculate edges and a result that holds up to close scrutiny. A project that speaks to our ability to work across multiple interior trades on a single build, delivering consistently from room to room.",
  },
];
